<template>
    <section class="faq__entry">
        <header v-if="!faqOpen">
            <div class="header--left">
            <div @click="move()" class="burger__button">
                <div class="burger__button--line">&nbsp;</div>
                <div class="burger__button--line">&nbsp;</div>
                <div class="burger__button--line">&nbsp;</div>
            </div>
            <h4>{{faq.question}}</h4>
            </div>
            <div class="header--right">
                <div class="button--wrapper" @click="open()">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M3.33380973,15.9106024 L8.09014637,20.6669782 C8.05801467,20.6838898 2.5195249,21.9886165 2.5195249,21.9886165 C2.37070441,22.0232852 2.22357507,21.9767785 2.12379769,21.8761547 C2.02063804,21.7721486 1.97751392,21.6224813 2.01133676,21.4804242 C2.01133676,21.4804242 3.31605274,15.9418888 3.33380973,15.9106024 L3.33380973,15.9106024 Z M14.5048929,4.71099215 L19.2881931,9.49429243 L8.70112076,20.0813648 L3.91787526,15.2981193 L14.5048929,4.71099215 Z M15.7027582,3.51372115 L20.4846114,8.29899601 L19.886452,8.89673258 L15.1045989,4.11145772 L15.7027582,3.51372115 Z M18.0932508,2 C18.6580922,2 19.1891107,2.21900468 19.5882202,2.61980862 L19.5882202,2.61980862 L21.3816762,4.41243382 C22.2061079,5.23687229 22.2061079,6.57795888 21.3816762,7.40155178 L21.3816762,7.40155178 L21.0823441,7.70088636 L16.2989492,2.91745205 L16.5982813,2.61980862 C16.9973908,2.21985026 17.5284094,2 18.0932508,2 Z" id="Combined-Shape" fill="#575C61"></path>
                        </g>
                    </svg>
                </div>
                <div class="button--wrapper" @click="remove(faq.id)">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-delete" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M12,0 C18.6281739,0 24,5.37182609 24,12 C24,18.6281739 18.6281739,24 12,24 C5.37182609,24 0,18.6281739 0,12 C0,5.37182609 5.37182609,0 12,0 Z M8.11289944,6.70970461 C7.72060824,6.40467972 7.15337718,6.43240926 6.79289322,6.79289322 C6.40236893,7.18341751 6.40236893,7.81658249 6.79289322,8.20710678 L6.79289322,8.20710678 L10.585,12 L6.79289322,15.7928932 L6.70970461,15.8871006 C6.40467972,16.2793918 6.43240926,16.8466228 6.79289322,17.2071068 C7.18341751,17.5976311 7.81658249,17.5976311 8.20710678,17.2071068 L8.20710678,17.2071068 L12,13.415 L15.7928932,17.2071068 L15.8871006,17.2902954 C16.2793918,17.5953203 16.8466228,17.5675907 17.2071068,17.2071068 C17.5976311,16.8165825 17.5976311,16.1834175 17.2071068,15.7928932 L17.2071068,15.7928932 L13.415,12 L17.2071068,8.20710678 L17.2902954,8.11289944 C17.5953203,7.72060824 17.5675907,7.15337718 17.2071068,6.79289322 C16.8165825,6.40236893 16.1834175,6.40236893 15.7928932,6.79289322 L15.7928932,6.79289322 L12,10.585 L8.20710678,6.79289322 Z" id="Combined-Shape" fill="#575C61" fill-rule="nonzero"></path>
                        </g>
                    </svg>
                </div>
            </div>
        </header>
        <header class="edit--header" v-else>
            <h4>{{$t('module.faq.edit')}}</h4>
        </header>
        <main v-if="faqOpen">
            <label class="label">{{$t('module.faq.question')}}</label>
            <input v-model="eq" type="text" class="input--text" id="question">
            <label class="label">{{$t('module.faq.answer')}}</label>
            <textarea v-model="ea" class="input--textarea" id="answer" rows="3"></textarea>
            <div class="button__wrapper">
                <btn @click="cancel()" :class="'btn--lightgray'" :text="$t('module.faq.cancel')" />
                <btn @click="save(faq.id)" :text="$t('module.faq.save')" />
            </div>
        </main>
    </section>
</template>

<script>
import Btn from '@/components/Button.vue';
export default {
    components: {
        Btn,
    },
    data() {
        return {
            faqOpen: false,
            eq: this.faq.question,
            ea: this.faq.answer
        }
    },
    emits: ['save-faq', 'delete-faq'],
    props: {
        faq: {
            type: Object,
            required: false
        },
    },
    methods: {
        open() {
            this.faqOpen = true;
        },
        close() {
            this.faqOpen = false;
        },
        remove(id) {
            this.$emit('delete-faq', id);
        },
        save(id) {
            this.$emit('save-faq', this.eq, this.ea, id);
            this.close();
        },
        cancel() {
            this.eq = this.faq.question;
            this.ea = this.faq.answer;
            this.close();
        }
    },
    created() {
        if(this.faq.question == "") {
            this.faqOpen = true;
        }
    },
}
</script>

<style lang="scss" scoped>
    .button--wrapper{
        padding: 27px 12px;
        display: inline-block;
    }
    .edit--header{
        padding-left: 80px;
    }
    .button__wrapper {
        text-align: right;
        margin-top: 25px;
    }
    .burger__button{
            display: inline-block;
            padding: 32px 30px;
            box-sizing: border-box;

        .burger__button--line{
            height: 1px;
            background-color: #575C61;
            width: 20px;
            margin: 6px 0;

            &:first-child{
                margin-top: 0;
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
    .faq__entry{
        cursor: pointer;
        background-color: #FFFFFF;
        border: 1px solid #D9D9D9;
        margin-bottom: 10px;

        input[type="text"] {
            width: 100%;
            box-sizing: border-box;
        }

        header{
            padding-right: 18px;
            display: flex;
            justify-content: space-between;

            .header--left{
                display: flex;
            }
            .header--right{
                display: flex;
            }

            h4{
                font-weight: bold;
                font-size: 26px;
                line-height: 82px;
                margin: 0;
            }
        }
        main {
            padding: 0 25px 25px 80px;
            padding-bottom: 25px;

            label:first-child{
                margin-top: 0;
            }
        }
    }
</style>